<!--
 * @Description: 购买页面
 * @Author: Zhang Xin (1483812724@qq.com)
 * @Date: 2023-06-29 14:15:19
 * @LastEditors: Wang Xiaowu (wangxiaowu@example.com)
 * @LastEditTime: 2024-03-13 13:16:34
 -->
<template>
  <div class="purchase">
    <div class="step">
      <el-steps :active="active" align-center>
        <el-step title="提交表单"></el-step>
        <el-step title="扫码支付"></el-step>
        <el-step title="联系我们"></el-step>
      </el-steps>
    </div>
    <div class="content">
      <div v-if="showOne">
        <div class="text1">
        <div class="title">选择运营商</div>
        <div class="operator">
          <div :class="show1 ? 'active' : ''" @click="handleSwitch(1)">
            中国移动
            <span class="sanjiao" v-if="show1"
              ><i class="el-icon-check"></i
            ></span>
          </div>
          <div :class="show2 ? 'active' : ''" @click="handleSwitch(2)">
            中国联通
            <span class="sanjiao" v-if="show2"
              ><i class="el-icon-check"></i
            ></span>
          </div>
          <div :class="show3 ? 'active' : ''" @click="handleSwitch(3)">
            中国电信
            <span class="sanjiao" v-if="show3"
              ><i class="el-icon-check"></i
            ></span>
          </div>
        </div>
      </div>
      <div class="text1">
        <div class="title year">购买年限</div>
        <div class="operator year">
          <div :class="shows1 ? 'active' : ''" @click="handleSwitchs(1)">
            <ul>
              <li class="li1">{{dataList[2].life}}年</li>
              <li class="li2">
                <span style="font-size: 12px">￥</span
                ><span style="font-size: 18px; font-weight: bold">{{dataList[2].packagePrice}}</span>/张
              </li>
              <li class="li3">每月仅{{dataList[2].price}}元</li>
            </ul>
            <span class="sanjiao" v-if="shows1"
              ><i class="el-icon-check"></i
            ></span>
          </div>
          <div :class="shows2 ? 'active' : ''" @click="handleSwitchs(2)">
            <ul>
              <li class="li1">{{dataList[1].life}}年</li>
              <li class="li2">
                <span style="font-size: 12px">￥</span
                ><span style="font-size: 18px; font-weight: bold">{{dataList[1].packagePrice}}</span>/张
              </li>
              <li class="li3">每月仅{{dataList[1].price}}元</li>
            </ul>
            <span class="sanjiao" v-if="shows2"
              ><i class="el-icon-check"></i
            ></span>
          </div>
          <div :class="shows3 ? 'active' : ''" @click="handleSwitchs(3)">
            <ul>
              <li class="li1">{{dataList[0].life}}年</li>
              <li class="li2">
                <span style="font-size: 12px">￥</span
                ><span style="font-size: 18px; font-weight: bold">{{dataList[0].packagePrice}}</span>/张
              </li>
              <li class="li3">每月仅{{dataList[0].price}}元</li>
            </ul>
            <span class="sanjiao" v-if="shows3"
              ><i class="el-icon-check"></i
            ></span>
          </div>
        </div>
      </div>
      <div class="text1">
        <div class="title">卡数量</div>
        <div class="notes">
          <el-input-number v-model="purchaseNum" :min="1" label="描述文字"></el-input-number>
        </div>
      </div>
      <div class="text1">
        <div class="title">上传文件</div>
        <div class="updown">
          <div class="uploadImg">
            <el-upload
              class="upload-demo"
              action
              :on-remove="handleRemove"
              :file-list="this.fileList"
              :http-request="handleHttpRequest"
              :before-upload="beforeAvatarUpload"
              :on-change="handleSomeimg"
              :limit="1"
              :on-exceed="handleExceed"
            >
              <div class="uploadBox">
                <i class="el-icon-plus"></i>
              </div>
            </el-upload>
          </div>
          <span>点击此处选择文件</span>
          <span style="color: #999"
            >文件中必须有IMEI或ICCID， <span style="color: #1890ff; cursor: pointer;" @click="handleTemplate">模板下载</span></span
          >
        </div>
      </div>
      <div class="text1">
        <div class="title">备注</div>
        <div class="notes">
          <el-input
          type="textarea"
          :rows="4"
          v-model="remark">
          </el-input>
        </div>
      </div>
      <div class="btn">
        <el-button style="margin-top: 12px" type="primary" @click="next(1)">提交</el-button>
        <el-button style="margin-top: 12px" @click="handleBack">取消</el-button>
      </div>
      </div>
      <div class="payment" v-if="showTwo">
        <div class="title">请选择支付方式</div>
        <div class="QRcode">
          <div>
            <span><img src="../../assets/img/purchase/weixin.png" alt=""></span>
            <span><img src="../../assets/img/purchase/weixinLogo.png" alt="">使用微信扫码付款</span>
          </div>
          <div>
            <span><img src="../../assets/img/purchase/zhifubao.png" alt=""></span>
            <span><img src="../../assets/img/purchase/zhifubaoLogo.png" alt="">使用支付宝扫码付款</span>
          </div>
        </div>
        <div class="codeBtn">
          <div><el-button style="margin-top: 12px" type="primary" @click="upper">上一步</el-button></div>
          <div><el-button style="margin-top: 12px" type="primary" @click="next(2)">下一步</el-button></div>
        </div>
      </div>
      <div class="phone" v-if="showThree">
        <div class="title">支付完成后请拨打以下电话联系我们:</div>
        <div class="tel">16638169018</div>
        <div><el-button style="margin-top: 12px" type="primary" @click="upper">上一步</el-button></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    urlData: {
      type: String,
      default: () => {
        return ""
      },
    },
  },
  data() {
    return {
      active: 0,
      show1: false,
      show2: false,
      show3: false,
      shows1: false,
      shows2: false,
      shows3: false,
      fileList: [],
      file: [],
      remark: '',
      showOne: true,
      showTwo: false,
      showThree: false,
      purchaseNum: 50,
      dataList: [],
      purchaseType: null, // 运营商
      packageType: null, // 套餐年限
    }
  },
  watch: {},
  created() {
    this.handleSwitch(1)
    this.handleSwitchs(1)
    let detailArr = JSON.parse(this.$route.query.data)
    this.dataList = detailArr
    console.log(111, this.dataList)
    this.dataList.forEach(item => {
      item.price = (item.packagePrice / 12 / item.life).toFixed(2)
    })
  },
  mounted() {},
  methods: {
    next(type) {
      if (type == 1) {
        if (this.fileList.length == 0) {
          this.$message({ type: 'warning', message: `请上传文件` })
        } else {
          let formData = new FormData()
          formData.append('file', this.fileList[0].raw)
          let preams = {
            purchaseType: this.purchaseType,
            packageType: this.packageType,
            purchaseNum: this.purchaseNum,
            remark: this.remark,
          }
          this.request.postParamsForm('/front/purchase/record/add', preams, formData).then(res => {
            if (res.code == 200) {
              this.$message({ type: 'success', message: `保存成功` })
              if (this.active++ > 2) this.active = 0
              if (this.active == 1) {
                this.showOne = false
                this.showTwo = true
              }
            }
          })
        }
      } else {
        if (this.active++ > 2) this.active = 0
        if (this.active == 2) {
          this.showOne = false
          this.showTwo = false
          this.showThree = true
        }
      }
    },
    upper() {
      if (this.active-- < 0) this.active = 2
      console.log(888, this.active)
      if (this.active == 0) {
        this.showOne = true
        this.showTwo = false
      }
      if (this.active == 1) {
        this.showOne = false
        this.showTwo = true
        this.showThree = false
      }
    },
    // 选择运营商
    handleSwitch(type) {
      if (type == 1) {
        this.show1 = true
        this.show2 = false
        this.show3 = false
        this.purchaseType = 1
      } else if (type == 2) {
        this.show1 = false
        this.show2 = true
        this.show3 = false
        this.purchaseType = 2
      } else {
        this.show1 = false
        this.show2 = false
        this.show3 = true
        this.purchaseType = 3
      }
    },
    // 选择套餐
    handleSwitchs(type) {
      if (type == 1) {
        this.shows1 = true
        this.shows2 = false
        this.shows3 = false
        this.packageType = 1
      } else if (type == 2) {
        this.shows1 = false
        this.shows2 = true
        this.shows3 = false
        this.packageType = 2
      } else {
        this.shows1 = false
        this.shows2 = false
        this.shows3 = true
        this.packageType = 3
      }
    },
    // 下载模板
    handleTemplate () {
      window.open(this.baseUrlAddr + '/front/purchase/record/downloadImeiTemplate')
    },
    // 返回到表格
    handleBack () {
      this.$router.push({
        path: "/tariffManagement",
      })
    },
    // 上传文件========================================================
    handleHttpRequest () {
      // this.handleSub()
    },
    handleSomeimg (file, fileList) {
      this.fileList = fileList
      console.log(88, this.fileList)
    },
    handleSub () {
      let formData = new FormData()
      formData.append('file', this.fileList[this.fileList.length - 1].raw)
      console.log(88, formData)
      // this.request.post('/front/file/uploadMinio', formData).then((res) => {
      //   console.log('上传', res)
      //   const files = {
      //     url: res.data,
      //     title: res.fileName,
      //   }
      //   this.msg.success('上传成功')
      //   if (this.file === undefined) {
      //     this.file = []
      //   }
      //   this.file.push(files)
      //   console.log('push信息', this.file)
      // })
    },
    beforeAvatarUpload (file) {
      var FileExt = file.name.replace(/.+\./, '')
      if (
        ['xlsx', 'xls'].indexOf(
          FileExt.toLowerCase()
        ) === -1
      ) {
        this.$message({
          type: 'warning',
          message: '请上传后缀名为xlsx、或xls的附件！',
        })
        return false
      }
    },
    handleRemove (file, fileList) {
      let fileID = file.uid
      this.fileList = fileList.filter((val) => {
        return val.uid != fileID
      })
      this.file.splice(
        this.file.findIndex((item) => item.title === file.name),
        1
      )
    },
    // 文件数量提醒
    handleExceed () {
      this.$message({ type: 'error', message: '最多支持1个附件上传' })
    },
  },
};
</script>

<style lang="scss" scoped>
.purchase {
  padding: 0 15px;
  height: 100%;
  .step {
    width: 100%;
    height: 80px;
    background-color: #fff;
    border-radius: 10px;
    padding: 14px 0;
    box-sizing: border-box;
  }
  .content {
    margin-top: 20px;
    width: 100%;
    height: calc(100% - 115px);
    background-color: #fff;
    border-radius: 10px;
    padding: 50px;
    position: relative;
    box-sizing: border-box;
    .text1 {
      display: flex;
      margin-bottom: 25px;
      > div {
        height: 40px;
        line-height: 40px;
      }
      .title {
        width: 100px;
      }
      .year {
        height: 100px;
        > div {
          padding: 0px 11px;
          width: 135px !important;
          box-sizing: border-box;
          > ul {
            li {
              height: 20px;
              text-align: left;
              margin-bottom: 5px;
            }
            .li1 {
              font-size: 14px;
            }
            .li3 {
              font-size: 14px;
            }
          }
        }
      }
      .operator {
        display: flex;
        > div {
          margin-left: 20px;
          width: 110px;
          text-align: center;
          border: 1px solid #c4c4c4;
          border-radius: 5px;
          cursor: pointer;
          position: relative;
          .sanjiao {
            display: block;
            position: absolute;
            right: 0;
            bottom: 0px;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 0 20px 20px;
            border-color: transparent transparent #1890ff transparent;
            /deep/.el-icon-check {
              position: absolute;
              right: 0;
              bottom: -22px;
              color: #fff;
            }
          }
        }
        .active {
          border-color: #1890ff;
          background: rgba(24, 144, 255, 0.1);
        }
      }
      .updown {
        width: 500px;
        height: 170px;
        border: 1px dashed #cfcfcf;
        margin-left: 20px;
        background-color: #f8fbff;
        border-radius: 10px;
        text-align: center;
        line-height: 60px;
        padding-top: 30px;
        > span {
          display: block;
          height: 30px;
        }
        .uploadImg {
          margin: 0 auto;
          .upload-demo {
            .uploadBox {
              width: 50px;
              height: 50px;
              border: 1px dashed #999;
              text-align: center;
              line-height: 50px;
              color: #999;
              position: relative;
              border-radius: 3px;
              i {
                font-size: 20px;
              }
              span {
                display: block;
                position: absolute;
                right: 13px;
                top: 28px;
              }
            }
            /deep/.el-upload-list {
              .el-upload-list__item {
                .el-icon-close {
                  color: #333;
                  right: 80px !important;
                }
              }
            }
          }
        }
      }
      .notes {
        margin-left: 20px;
        /deep/.el-textarea {
          width: 500px;
        }
      }
    }
    .btn {
      position: absolute;
      left: 170px;
      bottom: 50px;
      /deep/.el-button {
        width: 100px;
      }
    }
    .payment {
      text-align: center;
      width: 100%;
      padding-top: 100px;
      >div {
        margin: 0 auto;
      }
      .title {
        font-size: 18px;
        font-weight: bold;
      }
      .QRcode {
        width: 500px;
        display: flex;
        justify-content: space-between;
        margin-top: 50px;
        >div {
          span{
            display: block;
            margin-bottom: 10px;
           }
        }
      }
      .codeBtn {
        width: 400px;
        display: flex;
        justify-content: space-between;
        margin-top: 50px;
        >div {
            /deep/.el-button {
                width: 150px;
            }
        }
      }
    }
    .phone {
      text-align: center;
      width: 100%;
      padding-top: 100px;
      >div {
        margin-bottom: 30px;
        /deep/.el-button {
          width: 150px;
        }
      }
      .title {
        font-size: 18px;
        font-weight: bold;
      }
      .tel {
        font-size: 55px;
        font-weight: bold;
        color: #1890ff;
      }
    }
  }
}
</style>
<style lang="scss">
.el-step__head.is-process {
  color: #fff !important;
  border-color: #1890ff !important;
  .el-step__icon.is-text {
    background-color: #1890ff !important;
  }
}
.el-step__head.is-finish {
  color: #fff !important;
  border-color: #1890ff !important;
  .el-step__icon.is-text {
    background-color: #1890ff !important;
  }
  .el-step__line {
    background-color: #1890ff !important;
  }
}
.el-step__title.is-process {
  color: #000 !important;
}
.el-step__title.is-finish {
  color: #000 !important;
  font-weight: bold !important;
}
</style>
